import React from 'react';
import PropTypes from 'prop-types';
import PhysicianChatContactListUnreadEmptyState from './PhysicianChatContactListUnreadEmptyState';
import PhysicianChatContactListImportantEmptyState from './PhysicianChatContactListImportantEmptyState';

const PhysicianChatContactListEmptyState = ({ filter }) => {
  return (
    <div className="flex flex-col items-center flex-1 lg:border-r gap-4 pt-8 px-12">
      {filter === 'unread' ? (
        <PhysicianChatContactListUnreadEmptyState />
      ) : (
        <PhysicianChatContactListImportantEmptyState />
      )}
    </div>
  );
};

PhysicianChatContactListEmptyState.propTypes = {
  filter: PropTypes.string.isRequired,
};

export default PhysicianChatContactListEmptyState;
